import { Component, EventEmitter, Input, Output } from '@angular/core';

import { getEffectiveMaxQuantity } from '@cakeiteasy/web-utils';

import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';

@Component({
  standalone: false,
  selector: 'cake-counter',
  templateUrl: './cake-counter.component.html',
  styleUrls: ['./cake-counter.component.scss']
})
export class CakeCounterComponent {
  @Input() cartLine: ICakeCartLine;
  @Input() currency: string;
  @Input() disabled: boolean;
  @Input() discount: number;
  @Input() extraPrice = 0;
  @Input() extraCount = 0;

  @Output() onLineUpdated = new EventEmitter<ICakeCartLine>();

  public get maxCount(): number {
    return this.cartLine && this.cartLine.productType && getEffectiveMaxQuantity(this.cartLine.productType) || null;
  }
}
